<app-website-header></app-website-header>

<!-- Page Banner -->
<section class="page-banner">
    <div class="banner-content">
        <h1>Our <span class="highlight">Machine Tools</span></h1>
        <p>Explore our comprehensive range of precision machine tools and equipment.</p>
    </div>
</section>

<!-- Products Section -->
<section class="products-page-section">
    <div class="section-container">
        <div class="products-layout">
            <!-- Sidebar -->
            <aside class="products-sidebar">
                <!-- Search -->
                <div class="sidebar-search">
                    <div class="search-input-wrap">
                        <i class="fas fa-search"></i>
                        <input type="text" [(ngModel)]="searchQuery" (input)="onSearch()"
                            placeholder="Search machines...">
                    </div>
                </div>

                <!-- Category Filter -->
                <div class="sidebar-section">
                    <h4>Categories</h4>
                    <ul class="category-list">
                        <li [class.active]="selectedCategory === 0" (click)="selectCategory(0)">
                            <span class="cat-name"><i class="fas fa-th"></i> All Products</span>
                            <span class="cat-count">{{ getProductCount(0) }}</span>
                        </li>
                        <li *ngFor="let cat of categories" [class.active]="selectedCategory === cat.categoryId"
                            (click)="selectCategory(cat.categoryId)">
                            <span class="cat-name"><i class="fas fa-cog"></i> {{ cat.categoryName }}</span>
                            <span class="cat-count">{{ getProductCount(cat.categoryId) }}</span>
                        </li>
                    </ul>
                </div>

                <!-- Need Help -->
                <div class="sidebar-help">
                    <i class="fas fa-headset"></i>
                    <h4>Need Help?</h4>
                    <p>Contact us for expert advice on choosing the right machine.</p>
                    <a routerLink="/contact" class="help-btn">Contact Us</a>
                </div>
            </aside>

            <!-- Product Grid -->
            <div class="products-main">
                <div class="products-toolbar">
                    <div class="results-count">
                        Showing <strong>{{ filteredProducts.length }}</strong> products
                        <span *ngIf="selectedCategory !== 0"> in <strong>{{ getCategoryName(selectedCategory)
                                }}</strong></span>
                    </div>
                </div>

                <!-- Loading -->
                <div class="text-center py-5" *ngIf="isLoading">
                    <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
                    <p class="text-muted mt-2">Loading products...</p>
                </div>

                <div class="products-grid" *ngIf="!isLoading">
                    <div class="product-card" *ngFor="let product of filteredProducts">
                        <div class="product-image">
                            <img [src]="getProductImage(product)" [alt]="product.productName" loading="lazy">
                            <span class="product-badge" *ngIf="product.availability === 'IN_STOCK'">In Stock</span>
                        </div>
                        <div class="product-info">
                            <span class="product-category">{{ getCategoryName(product.categoryId) }}</span>
                            <h4>{{ product.productName }}</h4>
                            <p class="product-desc">{{ product.description }}</p>

                            <!-- Models & Specifications -->
                            <div class="product-models" *ngIf="product.models && product.models.length > 0">
                                <div class="model-block" *ngFor="let model of product.models; let mi = index">
                                    <div class="model-name" *ngIf="product.models.length > 1">
                                        <i class="fas fa-cube"></i> {{ model.modelName }}
                                    </div>
                                    <div class="product-specs"
                                        *ngIf="model.specificationValues && model.specificationValues.length > 0">
                                        <div class="spec" *ngFor="let sv of model.specificationValues">
                                            <i class="fas fa-bolt"></i>
                                            <div>
                                                <span class="spec-label">{{ sv.specification?.specName || 'Spec'
                                                    }}</span>
                                                <span class="spec-value">{{ sv.value }} {{ sv.specification?.unit ===
                                                    'N/A' ? '' : (sv.specification?.unit || '') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Price -->
                            <div class="product-price" *ngIf="product.price">
                                <span>₹{{ product.price | number }}</span>
                            </div>

                            <a [routerLink]="['/product', product.productId]"
                                class="btn-contact btn-block text-center mr-0">
                                View Details <i class="fas fa-arrow-right ml-1"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- No Results -->
                <div class="no-results" *ngIf="!isLoading && filteredProducts.length === 0">
                    <i class="fas fa-search"></i>
                    <h3>No products found</h3>
                    <p>Try adjusting your search or category filter.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Enquiry Modal -->
<div class="enquiry-modal-backdrop" *ngIf="isEnquiryModalOpen">
    <div class="enquiry-modal">
        <div class="enquiry-modal-header">
            <div>
                <h5 class="m-0"><i class="fas fa-paper-plane mr-2"></i>Contact Dealer</h5>
                <small class="text-light">Enquiry for: {{ enquiryProductName }}</small>
            </div>
            <button class="close-btn" (click)="closeEnquiryModal()">&times;</button>
        </div>
        <div class="enquiry-modal-body">
            <div class="row">
                <div class="col-md-6 form-group">
                    <label>Customer Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.customerName"
                        placeholder="Your full name">
                </div>
                <div class="col-md-6 form-group">
                    <label>Phone Number <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.phoneNumber"
                        placeholder="Your phone number">
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 form-group">
                    <label>Door No</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.doorNo"
                        placeholder="Door / Plot number">
                </div>
                <div class="col-md-4 form-group">
                    <label>Street</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.street" placeholder="Street name">
                </div>
                <div class="col-md-4 form-group">
                    <label>Village</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.village"
                        placeholder="Village / Area">
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 form-group">
                    <label>City</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.city" placeholder="City">
                </div>
                <div class="col-md-4 form-group">
                    <label>State</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.state" placeholder="State">
                </div>
                <div class="col-md-4 form-group">
                    <label>Pincode</label>
                    <input type="text" class="form-control" [(ngModel)]="enquiryForm.pincode" placeholder="Pincode">
                </div>
            </div>
            <div class="form-group">
                <label>Message</label>
                <textarea class="form-control" [(ngModel)]="enquiryForm.message" rows="3"
                    placeholder="Your message or specific requirements..."></textarea>
            </div>
            <div class="text-right mt-3">
                <button type="button" class="btn btn-secondary mr-2" (click)="closeEnquiryModal()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitEnquiry()" [disabled]="isSubmitting">
                    <i class="fas fa-paper-plane mr-1" *ngIf="!isSubmitting"></i>
                    <i class="fas fa-spinner fa-spin mr-1" *ngIf="isSubmitting"></i>
                    {{ isSubmitting ? 'Sending...' : 'Send Enquiry' }}
                </button>
            </div>
        </div>
    </div>
</div>

<app-website-footer></app-website-footer>